import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo, useContext, useEffect } from 'react';
import { MultiFormContext, MultiFormVolatileContext } from '../multi-form';
import { merge, pick, isArray, isPlainObject } from 'lodash';

function useForms(formConfigsOrIds) {
  var _useContext = useContext(MultiFormContext),
      setFormConfigs = _useContext.setFormConfigs; // TODO: This is not ideal as this hook will re-render
  // whenever ANY form within the multi-form changes,
  // not just the ones passed to this hook
  // I have done this to be able to share the logic
  // that is handled within the MultiForm component
  // Solution might be to bring that logic out into
  // it's own hook / utility function that does the same
  // thing but on an individual form level


  var _useContext2 = useContext(MultiFormVolatileContext),
      forms = _useContext2.forms;

  var configs = useMemo(function () {
    if (isPlainObject(formConfigsOrIds)) {
      // We have been given an object of
      // form configs so just return it as is
      return formConfigsOrIds;
    } else if (isArray(formConfigsOrIds)) {
      // We have been given a list of ids so
      // map these to a formConfigs object
      // with empty options
      return _reduceInstanceProperty(formConfigsOrIds).call(formConfigsOrIds, function (acc, id) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, id, {}));
      }, {});
    }
  }, [formConfigsOrIds]);
  var formIds = useMemo(function () {
    if (isArray(formConfigsOrIds)) {
      return formConfigsOrIds;
    } else if (isPlainObject(formConfigsOrIds)) {
      return _Object$keys(formConfigsOrIds);
    }
  }, [formConfigsOrIds]);
  useEffect(function () {
    // Merge here to not squash any config
    // values that may be defined statically
    // on the MultiForm provider component
    setFormConfigs(function (prevConfigs) {
      return merge({}, prevConfigs, configs);
    });
  }, [configs, setFormConfigs]);
  return useMemo(function () {
    return pick(forms, formIds);
  }, [formIds, forms]);
}

export { useForms };